import { render, staticRenderFns } from "./czlist.vue?vue&type=template&id=a7181cfe&scoped=true&"
import script from "./czlist.vue?vue&type=script&lang=js&"
export * from "./czlist.vue?vue&type=script&lang=js&"
import style0 from "./czlist.vue?vue&type=style&index=0&id=a7181cfe&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7181cfe",
  null
  
)

export default component.exports